module.exports = __webpack_public_path__ + "static/media/male-non-traditional-small.2c2442ae.mp4";